import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "./actions";
import ProductDetails from "containers/ProductDetails/components/ProductDetails";
import {
    createCommaSeparatedQueryArg,
    matchApplicationHash,
    getFiltersFromSearch
} from "./helpers";
import { animateScroll as scroll } from "react-scroll";
import { JSONLD, Product, Generic } from "react-structured-data";
import * as APPLICATIONS from 'constants/applications';

export class ProductDetailsContainer extends Component {
    constructor(props) {
        super(props);

        const { options } = props;

        const selectedGlassType =
            options.glass && options.glass.length > 0
                ? options.glass[0].hash
                : null;

        const selectedGlassDesign = selectedGlassType
            ? options.glass.find(opt => opt.hash === selectedGlassType)
                  .designs[0].hash
            : null;

        this.state = {
            activeTab: null,
            activeImage: null,
            displayAllImages: false,
            selectedGlassType,
            selectGlassTypeScrollPos: 0,
            selectedGlassDesign,
            selectGlassDesignScrollPos: 0,
            selectSpecieScrollPos: 0,
            selectStickingScrollPos: 0,
            swatchSize: 64
        };

        this.updateMetaTags();
    }

    updateMetaTags() {
        const titleTag = document.querySelector("title");
        const descriptionTag = document.querySelector(
            'meta[name="description"]'
        );
        const canonicalTag = document.querySelector('link[rel="canonical"]');
        const hostPath = window.location.host;
        const currentPath = this.props.location.pathname;

        if (titleTag) {
            titleTag.innerHTML = this.props.product.meta_title ? this.props.product.meta_title : this.props.product.title.concat(" ", this.props.product.subtitle + ' Door | Masonite UK Fire Doorsets');
        }

        if (canonicalTag) {
            canonicalTag.href = `${hostPath}${currentPath}`;
        }

        if (descriptionTag) {
            descriptionTag.innerHTML = this.props.product.meta_description ? this.props.product.meta_description : this.props.product.short_description;
        } else {
            const el = document.createElement("meta");
            const attribute = document.createAttribute("name");
            attribute.value = "description";
            el.setAttributeNode(attribute);
            el.innerHTML = this.props.product.meta_description;
        }
    }

    componentDidMount() {
        this.updateActiveTab();
        scroll.scrollToTop({ ignoreCancelEvents: true });
    }

    updateActiveTab = () => {
        const { props } = this;
        const selectedFilterOptions = getFiltersFromSearch(props.location);
        const appHash = selectedFilterOptions.find(matchApplicationHash);
        const defaultAppHash = APPLICATIONS.INTERNAL;
        const hash = appHash ? appHash : defaultAppHash;

        this.setState({
            activeTab: props.options.application.find(
                option => option.hash === hash
            )
        });

        this.modifyExternalDomElements();
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.search !== prevProps.location.search) {
            this.updateActiveTab();
        }

        if (this.state.activeTab !== prevState.activeTab) {
            const { images } = this.state.activeTab;

            if (images.length) {
                const hasTextured = images.find(
                    ({ type }) => type === "textured"
                );
                const defaultImage = hasTextured ? hasTextured : images[0];
                this.setState({ activeImage: defaultImage });
            }
        }

        this.modifyExternalDomElements();
    }

    /**
     * Modify external DOM elements.
     *
     * Modify elements outside of the React app, which are from WordPress.
     */
    modifyExternalDomElements() {
        if (this.props.wpFooterLoaded) {
            const el = document.querySelector(".before-footer");
            if (el) el.style.display = "block";
        }
    }

    getFilterOptionSelection = filter => {
        const { location, options } = this.props;
        if (!options[filter]) return false;
        const hashes = options[filter].filter(({ hash }) =>
            getFiltersFromSearch(location).includes(hash)
        );
        return hashes.slice(-1)[0];
    };

    changeTab = newTabHash => {
        const { history, location } = this.props;
        const nextFilters = getFiltersFromSearch(location)
            .filter(hash => !matchApplicationHash(hash))
            .concat(newTabHash);
        let search = "";

        if (nextFilters.length === 1 && nextFilters.includes(APPLICATIONS.INTERNAL)) {
            search = "";
        } else {
            search = "?" + createCommaSeparatedQueryArg("filters", nextFilters);
        }

        history.push({ search });
    };

    setContainerState = key => val => {
        // don't fire a state change if nothing actually changes
        if (this.state[key] !== val) {
            this.setState({ [key]: val });
        }
    };

    render() {
        const application = this.getFilterOptionSelection("application");
        const { activeImage, activeTab, displayAllImages } = this.state;

        return (
            activeTab && (
                <>
                    <JSONLD>
                        <Generic
                            jsonldtype="WebPage"
                            url={window.location.href}
                        >
                            <Product
                                type="mainEntity"
                                name={this.props.product.meta_title}
                                description={
                                    this.props.product.meta_description
                                }
                                image={activeTab.images[0].image}
                                brand={{
                                    "@type": "Organization",
                                    name: "Masonite"
                                }}
                            />
                        </Generic>
                    </JSONLD>
                    <ProductDetails
                        {...this.props}
                        containerState={this.state}
                        application={application}
                        changeTab={this.changeTab}
                        activeTab={activeTab}
                        activeImage={activeImage}
                        setContainerState={this.setContainerState}
                        displayAllImages={displayAllImages}
                        key={displayAllImages}
                    />
                </>
            )
        );
    }
}

const mapStateToProps = state => {
    return {
        product: state.productDetails.content,
        options: state.productDetails.options,
        lastCatalogPath: state.catalog.lastPath,
        interiorRoute: state.catalog.interiorRoute,
        exteriorRoute: state.catalog.exteriorRoute,
        allDoorsRoute: state.catalog.allDoorsRoute,
        wpFooterLoaded: state.app.wpFooterLoaded
    };
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

ProductDetailsContainer.propTypes = {
    product: PropTypes.object,
    options: PropTypes.object
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ProductDetailsContainer)
);
